import { Config } from "../../../configurations/config";

export  const MonthlyTimesheetConfigAPIs  = {
    GetMonthlyTimesheetConfig:`${Config.server_url}${Config.api_prefix}/TimeSheet/MonthlyTimesheet/Config`,
    GenerateMonthlyReportForcefully:`${Config.server_url}${Config.api_prefix}/TimeSheet/MonthlyTimesheet/Config/GenerateTimesheets`
}